import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ln-icon-error",
  "use": "ln-icon-error-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"ln-icon-error\"><g fill=\"none\"><path d=\"M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z\" fill=\"#D0021B\" /><path d=\"M9 5L9 11.5C9 12.0522847 9.44771525 12.5 10 12.5 10.5522847 12.5 11 12.0522847 11 11.5L11 5C11 4.44771525 10.5522847 4 10 4 9.44771525 4 9 4.44771525 9 5zM9.29289322 15.7071068C9.68341751 16.0976311 10.3165825 16.0976311 10.7071068 15.7071068 11.0976311 15.3165825 11.0976311 14.6834175 10.7071068 14.2928932 10.3165825 13.9023689 9.68341751 13.9023689 9.29289322 14.2928932 8.90236893 14.6834175 8.90236893 15.3165825 9.29289322 15.7071068z\" fill=\"#FFFFFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ln-icon-error.svg
// module id = 1174
// module chunks = 0